import { createStyled as t, shouldForwardProp as r } from "@mui/system";
import e from "./defaultTheme.mjs";
import d from "./identifier.mjs";
const s = (o) => r(o) && o !== "classes", c = r, f = t({
  themeId: d,
  defaultTheme: e,
  rootShouldForwardProp: s
});
export {
  f as default,
  s as rootShouldForwardProp,
  c as slotShouldForwardProp
};
//# sourceMappingURL=styled.mjs.map
